export const FLAG_LANGUAGE_ASSIST = 'language-assist';
export const FLAG_ENQUIRE_NOW = 'enquire-now';
export const FLAG_XERO_INTEGRATION = 'xero-integration';
export const FLAG_STRIPE_INTEGRATION = 'stripe-integration';
